export enum SettingKey {
  USER_AUTH_ENABLED = 'USER_AUTH_ENABLED',
  USER_CREATION_ENABLED = 'USER_CREATION_ENABLED',
  WEET_CREATION_ENABLED = 'WEET_CREATION_ENABLED',
  WEET_MAX_LIMIT = 'WEET_MAX_LIMIT',
  INFORMATION_MESSAGE = 'INFORMATION_MESSAGE',
  CDN_IMAGE_URL='CDN_IMAGE_URL',
  CDN_VIDEO_URL='CDN_VIDEO_URL'
}
